import React from "react";
import MainHero from "./components/MainHero/MainHero";
import Contact from "./components/Contact/Contact";
import Navbar from "./components/Navbar/Navbar";
import Projects from "./components/Projects/Projects";
import About from "./components/About/About";
import Footer from "./components/Footer/Footer";
import Particle from "./components/Particles/Particle";

const App = () => {
  return (
    <>
      <main className="">
        <Particle />
        <header className="text-white flex items-center flex-col h-screen">
          <div className="w-11/12 lg:w-4/5 sticky">
            <Navbar />
          </div>
          <div className="flex flex-col justify-evenly w-11/12 h-full lg:w-4/5">
            <MainHero />
          </div>
        </header>
        <section className="flex justify-center items-center">
          <About />
        </section>
        <section className="flex flex-col items-center justify-center">
          <Projects />
        </section>
        <section className="flex justify-center items-center">
          <Contact />
        </section>
      </main>
      <Footer />
    </>
  );
};

export default App;
